import React from 'react';
import { motion } from 'framer-motion';
import {
  FaWhatsapp,
  FaTelegramPlane,
  FaComments,
  FaRobot,
  FaCheckDouble,
  FaRoute,
  FaShieldAlt,
  FaUsers,
  FaCamera,
  FaCheckCircle
} from 'react-icons/fa';
import { IconType } from 'react-icons';
import './Connectors.scss';

interface Point {
  id: string;
  title: string;
  description: string;
  icon: IconType;
}

interface ChatMessage {
  id: number;
  from: 'user' | 'bot';
  text?: string;
  photo?: boolean;
  card?: [string, string][];
  done?: boolean;
  time: string;
}

const platforms: { id: string; label: string; icon: IconType }[] = [
  // @ts-ignore
  { id: 'whatsapp', label: 'WhatsApp', icon: FaWhatsapp },
  // @ts-ignore
  { id: 'telegram', label: 'Telegram', icon: FaTelegramPlane }
];

const points: Point[] = [
  {
    id: 'habit',
    title: 'Пишите как привыкли',
    description: 'Текст, фото и уточнения можно слать несколькими сообщениями — бот соберёт их в одну заявку.',
    // @ts-ignore
    icon: FaComments
  },
  {
    id: 'ai',
    title: 'ИИ отличает заявку от переписки',
    description: 'Приветствия, обсуждения и «спасибо» остаются обычными сообщениями. Заявкой становятся только реальные просьбы и проблемы.',
    // @ts-ignore
    icon: FaRobot
  },
  {
    id: 'confirm',
    title: 'Подтверждение одним словом',
    description: 'Бот показывает карточку заявки — достаточно ответить «да». Понимает русский, казахский и английский.',
    // @ts-ignore
    icon: FaCheckDouble
  },
  {
    id: 'routing',
    title: 'Сразу к ответственному',
    description: 'Заявка получает раздел, попадает к нужному сотруднику и отслеживается до закрытия.',
    // @ts-ignore
    icon: FaRoute
  }
];

const chatMessages: ChatMessage[] = [
  { id: 1, from: 'user', text: 'В переговорной на 3 этаже не работает кондиционер', time: '09:41' },
  { id: 2, from: 'user', photo: true, time: '09:41' },
  {
    id: 3,
    from: 'bot',
    card: [
      ['Раздел', 'Техобслуживание'],
      ['Суть', 'Не работает кондиционер в переговорной, 3 этаж'],
      ['Фото', '1 шт.']
    ],
    text: 'Всё верно? Ответьте «да», и я отправлю заявку.',
    time: '09:41'
  },
  { id: 4, from: 'user', text: 'да', time: '09:42' },
  { id: 5, from: 'bot', done: true, text: 'Заявка №1284 создана и передана ответственному.', time: '09:42' }
];

const Connectors: React.FC = () => {
  const renderIcon = (IconComponent: IconType, props: any = {}) => {
    // @ts-ignore
    return <IconComponent {...props} />;
  };

  const chatVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.45, delayChildren: 0.3 } }
  };

  const messageVariants = {
    hidden: { opacity: 0, y: 12, scale: 0.97 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.4, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <section id="connectors" className="connectors section">
      <div className="container">
        <div className="connectors__layout">
          <motion.div
            className="connectors__text"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-badge">WhatsApp и Telegram</span>
            <h2 className="connectors__title">
              Не нужно осваивать приложение.
              <br /><span className="text-gradient">Просто напишите в чат</span>
            </h2>
            <p className="connectors__subtitle">
              Создавайте заявки прямо в общем WhatsApp или Telegram чате — так, как вы уже привыкли.
              beheard сам распознает заявку, уточнит детали и передаст её ответственному.
            </p>

            <div className="connectors__platforms">
              {platforms.map((platform) => (
                <span key={platform.id} className={`platform-chip platform-chip--${platform.id}`}>
                  {renderIcon(platform.icon)}
                  {platform.label}
                </span>
              ))}
            </div>

            <div className="connectors__points">
              {points.map((point) => (
                <div key={point.id} className="connector-point">
                  <div className="connector-point__icon">
                    {renderIcon(point.icon)}
                  </div>
                  <div>
                    <h4 className="connector-point__title">{point.title}</h4>
                    <p className="connector-point__description">{point.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>

          <div className="connectors__visual">
            <motion.div
              className="chat-mock"
              initial={{ opacity: 0, y: 30, scale: 0.97 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="chat-mock__header">
                <div className="chat-mock__avatar">
                  {/* @ts-ignore */}
                  <FaUsers />
                </div>
                <div className="chat-mock__info">
                  <span className="chat-mock__name">Офис · общий чат</span>
                  <span className="chat-mock__members">48 участников, beheard-бот</span>
                </div>
              </div>

              <motion.div
                className="chat-mock__body"
                variants={chatVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: '-80px' }}
              >
                {chatMessages.map((message) => (
                  <motion.div
                    key={message.id}
                    className={`chat-bubble chat-bubble--${message.from}`}
                    variants={messageVariants}
                  >
                    {message.from === 'bot' && <span className="chat-bubble__author">beheard</span>}
                    {message.photo && (
                      <div className="chat-bubble__photo">
                        {/* @ts-ignore */}
                        <FaCamera />
                        <span>Фото</span>
                      </div>
                    )}
                    {message.card && (
                      <div className="chat-bubble__card">
                        <span className="chat-bubble__card-title">Новая заявка</span>
                        {message.card.map(([label, value]) => (
                          <div key={label} className="chat-bubble__card-row">
                            <span className="chat-bubble__card-label">{label}</span>
                            <span className="chat-bubble__card-value">{value}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {message.text && (
                      <p className="chat-bubble__text">
                        {/* @ts-ignore */}
                        {message.done && <FaCheckCircle className="chat-bubble__done" />}
                        {message.text}
                      </p>
                    )}
                    <span className="chat-bubble__time">{message.time}</span>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </div>

        <motion.div
          className="connectors__guarantee"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="connectors__guarantee-icon">
            {/* @ts-ignore */}
            <FaShieldAlt />
          </div>
          <div>
            <h3 className="connectors__guarantee-title">Вы не потеряете ни одну заявку</h3>
            <p className="connectors__guarantee-text">
              Каждое обращение из чата сохраняется в системе со статусом и ответственным — даже если переписка
              давно ушла вверх, а автор ещё не зарегистрирован в beheard.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Connectors;
